const config = {
  serverURL: "https://retailhub-server.onrender.com/",
  localURL: "http://localhost:4000/",
  URL: "https://retailhub-server.onrender.com/",
};

export default config;
